import { Box, Stack, Typography, type BoxProps } from '@mui/material';
import { type ReactNode } from 'react';

export function Section({
  title,
  description,
  action,
  children,
  ...rest
}: { title?: string; description?: string; action?: ReactNode; children: ReactNode } & BoxProps) {
  return (
    <Box {...rest} sx={{ mb: 4, ...(rest.sx ?? {}) }}>
      {(title || description || action) && (
        <Stack
          direction="row"
          alignItems="flex-end"
          justifyContent="space-between"
          sx={{ mb: 2 }}
        >
          <Box>
            {title && (
              <Typography variant="h6" sx={{ fontSize: 17, fontWeight: 600 }}>
                {title}
              </Typography>
            )}
            {description && (
              <Typography variant="body2" sx={{ mt: 0.5 }}>
                {description}
              </Typography>
            )}
          </Box>
          {action}
        </Stack>
      )}
      <Stack spacing={1.5}>{children}</Stack>
    </Box>
  );
}

export function PageHeader({ title, description }: { title: string; description?: string }) {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h4" sx={{ fontSize: 28 }}>
        {title}
      </Typography>
      {description && (
        <Typography variant="body2" sx={{ mt: 1, maxWidth: 720 }}>
          {description}
        </Typography>
      )}
    </Box>
  );
}
